import React from "react";
import CloseIcon from "@mui/icons-material/Close";
import { useTranslation } from "react-i18next";
import { ArcIconButton, ArcStack, ArcText } from "@src/core/ui";

interface FilterChipProps {
  label: string;
  onRemove: () => void;
}

const FilterChip: React.FC<FilterChipProps> = ({ label, onRemove }) => {
  const { t } = useTranslation();

  return (
    <ArcStack
      direction="row"
      alignItems="center"
      spacing={0.5}
      bgcolor="background.chip"
      borderRadius="29px"
      px={1}
      py={0.5}>
      <ArcText fontSize={12} color="brand.main">
        {label}
      </ArcText>
      <ArcIconButton
        size="small"
        type="button"
        aria-label={t("history.filter.chip.remove", { label })}
        sx={{ p: 0.15, color: "brand.main", "&:hover": { bgcolor: "action.hover" } }}
        onClick={(e) => {
          e.stopPropagation();
          onRemove();
        }}>
        <CloseIcon sx={{ width: 12, height: 12 }} />
      </ArcIconButton>
    </ArcStack>
  );
};

export default FilterChip;
